var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_249_125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_249_125",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_249_125",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_249_125",
    width: 128,
    height: 128,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADdgAAA3YBfdWCzAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAARHSURBVHic7Z07TiNRFETPYxfsgwSJLbAXJrKIHRDCWmALSCReB6zC3AkwoxE/2033e3U/VyqR2O26VUc23bbUzcwAaK2dA9fAGW+zAW7M7Ikat7O31x0AK2AL2AdtgbWZUfInYP1DryszowHnwCNw8gNId2b2ZzYsaxaf1totcPXDQ16BiwbcA5cHHLMgcDIHlP8+Dw14Bk4PPHZBID5HlA/w8tPb/ldztXuBGsE5snzg7XN/c+TrFASCM6V8YHPoP4FfTX0ciMzE8l+Bi/9PFz6eKhyi29GnOtkF3E7sbm1mzHGggsBf+f86m/2AJT/lfwKgIPChOTta/AVKuuV/C0BBoKklOun+giWd8vcCUBBoaMkOhhsojc1exkhpTOZyhkp9s5Y1llk9M5Y3mE29s3VjNINGZOrOcFSNytKt8UgamaH7BbxrdHZhFvEohczCLeRFKlmFXUxZShmFX1BNatmkWVRBipmkW7jK7wiA8uJVficA1APIvnsFkXznCiT5rhVM8h0roOS7VVDJd6rAku9SwSXfYXh47gN07F0GAK9BevQsC4C3QD15dQOAl2A9eHQLgHrAyt7CAKAatKKnsACoBa7kJQ0AKsEreEgLwOgCIpfvBoBRRUQv3xUAvQvJUL47AHoVk6V8lwAsXVCm8t0CsFRR2cp3DcDchWUs3z0AcxWXtXwzo+0CcD0Tb5gAcLf7O+m5FuCGGSEAgF9BMGVClA/H3yZGdnaF3O194O8nTPkQCADoAkGo8iEYALAoBOHKh4AAwCIQhCwfggIAs0IQtnwIDADMAkHo8iE4ADX7JzQAM1wbCH+b3LAAzHhhKDQEIQFY4KpgWAjCAbDgJeGQEIQCoMP3AeEgCANAxy+DQkEQAoBffh085TpBHAhG/yChfhAyOL/RBkaXnx2C4QYUys8MwXADKuVnhWC4AaXyM0Iw3IBa+dkgGG5AuZAMEAw3oF5EdAiGG/BQgIKHlAAoBa/kJQUAioEregoJgHLQyt5CAOAhYA8eXQLgKVhPXl0A4DFQj54lAfAcpGfvEgB4D9D7DhVc8l0qsOQ7VVDJd6uAku9YwSTftQJJvnMFkXz39AFkhyDt4gXBwgCoLlwQdABAcVEVqWUTfkFFKWUUdjF1qWQVbiFPUsgszCJeNTo79wtE0MgM3RqPplFZujMcWSMydWM0i3pnK28wo3pmLGssu3plLWeo1DdzGSOlMdkPN1AaC0GV70RLdVHlO9ISnVT5zjR3N1W+Q83ZUZXvVHN1VeU71hydvR9oXeX71C8gWJsZDTgHHjn+5hHhb6roZSbeMOMVuGjAPXB55JOrfLGZCMFDA56B0yOeVOWLzgQIXuptP9DYhHslnwCbAx9b5TuYIyHYHPpPYJXvbA74OHgFLt5PJVbAls+nClt2pwslf+Lt9P67XldmRts9kNbaOXANnO0I2QA3ZvY0H5c1vWdfr38BG0HcMgEc6jsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.3f950dc1ea7bb6a14873a343aabd105a.svg";
export { ForwardRef as ReactComponent };